import { useReducer } from 'react';

const initialState = {
  isOpen: false
};

const ACTION_TYPES = {
  OPEN_ON_HOLD_DIALOG: 'OPEN_ON_HOLD_DIALOG',
  CLOSE_ON_HOLD_DIALOG: 'CLOSE_ON_HOLD_DIALOG'
};

const ACTIONS = {
  openOnHoldDialog: () => ({
    type: ACTION_TYPES.OPEN_ON_HOLD_DIALOG
  }),
  closeOnHoldDialog: () => ({
    type: ACTION_TYPES.CLOSE_ON_HOLD_DIALOG
  })
};

const reducer = (state, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN_ON_HOLD_DIALOG: {
      return {
        isOpen: true
      };
    }

    case ACTION_TYPES.CLOSE_ON_HOLD_DIALOG: {
      return {
        isOpen: false
      };
    }

    default: {
      throw Error('useOnHoldDialog reducer should never hit default');
    }
  }
};

const useOnHoldDialog = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const open = () =>
    dispatch(
      ACTIONS.openOnHoldDialog()
    );

  const close = () => dispatch(ACTIONS.closeOnHoldDialog());

  const boundActions = {
    open,
    close
  };

  return [state, boundActions];
};

export default useOnHoldDialog;
